import SiteHeader from './components/site-header';
import HandheldMenu from "./components/handheld-menu";
import CookiesConsent from "./components/cookies-consent";
import DropdownMenu from "./components/dropdown-menu";
import Accordion from "./components/accordion";
import Tabs from "./components/tabs";
import SlidesOffers from "./components/slides-offers";
import NewsSlider from "./components/news-slider";
import DeviceManager from './utils/device-manager';
import PropertySlider from './components/property-slider';
import SeeMore from './components/see-more';
import SearchList from './components/search-drop-list';
import SearchBox from './components/search-box';


(function($) {
    window.$ = $;
    const lang = typeof pro.lang !== 'undefined' ? pro.lang : 'en';

    $(function() {
        const $html = $('html');

        // Touch device detection
        if(DeviceManager.isHandheld()) {
            $html.addClass('touch');

            if(DeviceManager.isIos()) {
                $html.addClass('ios');
            }
        }
        else {
            $html.addClass('no-touch');
        }

        // IE detection
        if(DeviceManager.isIe11()) {
            $html.addClass('ie11');
        }
        else if(DeviceManager.isEdge()) {
            $html.addClass('edge');
        }

        // Handheld menu
        const handheldMenu = new HandheldMenu();

        // General components
        const siteHeader = new SiteHeader($('.site-header'), 20);
        //const dropdownMenu = new DropdownMenu($('.header__nav'));

         // Slides offers component
         /*const $slidesOffers = $('.slider-offers');
         if($slidesOffers.length) {
            $slidesOffers.each(function(index, el) {
                 let slidesOffers = new SlidesOffers($(el));
             });
         }*/

        // Product list component
        const $sliderProducts = $('.products-list__wrapper');
        if($sliderProducts.length) {
            $sliderProducts.each(function(index, el) {
                let sliderProducts = new ProductsSlider($(el));
            });
        }

        // Image with hotspots component
        const $imagesWithHotspots = $('.image-hotspots-selector');
        if($imagesWithHotspots.length) {
            $imagesWithHotspots.each(function(index, el) {
                let imageWithHotspots = new ImageHotspotsSelector($(el));
            });
        }

        // Catalog load more component
        const $catalogLoadMoreBtns = $('.results-list__load-more-link');
        if($catalogLoadMoreBtns.length) {
            $catalogLoadMoreBtns.each(function(index, el) {
                let catalogLoadMore = new CatalogLoadMore($(el));
            });
        }

        // Catalog search form component
        const $catalogSearchForms = $('.catalog-search');
        if($catalogSearchForms.length) {
            $catalogSearchForms.each(function(index, el) {
                let catalogSearchForm = new CatalogSearchForm($(el));
            });
        }

        // Cookie consent
        if(typeof tarteaucitron !== 'undefined' && tarteaucitron) {
            // Tarteaucitron cookie settings
            let tarteaucitronLang = lang || 'en';

            if(lang === 'cn') {
                tarteaucitronLang = 'en';
            }

            const cookiesConsent = new CookiesConsent(tarteaucitronLang);
        }

        // Les liens dans les fiches d'un bien s'ouvrent dans une nouvelle fenêtre
        $('.property-presentation__content-text a').each(function() {
            $(this).attr('target', '_blank');
        });
    });
    

})(jQuery);
